// How many video-card columns a page may use, from how many cards it has. Few cards stay in a
// few wide columns with the spare width in the side gutters; a long list gets up to 6 so more
// of it fits on screen. The .lib-page wrapper (library.css) turns the count into the page's
// max width, so the header and grid stay left-aligned with each other and centred together.
import type { CSSProperties } from "react";

/** `more`: further pages are still to load, so the list is long whatever has arrived. */
export function cardColumns(count: number, more = false): number {
  if (more || count > 18) return 6;
  if (count > 12) return 5;
  if (count > 6) return 4;
  return 3;
}

export function cardPageStyle(count: number, more = false): CSSProperties {
  return { "--lib-cols": cardColumns(count, more) } as CSSProperties;
}
